import pdfMake from "pdfmake/build/pdfmake.min";
import pdfFonts from "pdfmake/build/vfs_fonts";

pdfMake.vfs = pdfFonts.vfs;

export const usePdfExport = () => {

    const headerColor = "#0e7490"

    const downloadPDF = ({
        tableLeadReports,
        currency,
        downloadReportTitle,
        formatDateByCountry,
        USAComma
    }) => {

        const now = new Date();
        const day = now.getDate();
        const month = now.toLocaleString("en-US", { month: "short" });
        const year = now.getFullYear();
        const fileName = `${downloadReportTitle}_${day}_${month}_${year}.pdf`;

        // Table header row
        const headerRow = [
            {
                text: "Sr.No",
                style: "tableHeader",
                fillColor: headerColor,
                color: "white",
            },
            {
                text: "Lead Date",
                style: "tableHeader",
                fillColor: headerColor,
                color: "white",
            },
            {
                text: "Client Name",
                style: "tableHeader",
                fillColor: headerColor,
                color: "white",
            },
            {
                text: "Project Name",
                style: "tableHeader",
                fillColor: headerColor,
                color: "white",
            },
            {
                text: "Lead Type",
                style: "tableHeader",
                fillColor: headerColor,
                color: "white",
            },
            {
                text: `Quoted Value (${currency})`,
                style: "tableHeader",
                fillColor: headerColor,
                color: "white",
            },
            {
                text: "Source",
                style: "tableHeader",
                fillColor: headerColor,
                color: "white",
            },
            {
                text: "Status",
                style: "tableHeader",
                fillColor: headerColor,
                color: "white",
            },
            {
                text: "Group",
                style: "tableHeader",
                fillColor: headerColor,
                color: "white",
            },
            {
                text: "Follow-up Date",
                style: "tableHeader",
                fillColor: headerColor,
                color: "white",
            }
        ];

        // Body rows with alternating colors
        const bodyRows = tableLeadReports.map((LeadReport, index) => {
            const isEvenRow = index % 2 === 0;

            const bgColor = isEvenRow ? "#ffffff" : "#f3f4f6"; // blue-50 / gray-50

            return [
                { text: index + 1, fillColor: bgColor, style: "tableBody" },
                { text: LeadReport.LeadDate ? formatDateByCountry(LeadReport.LeadDate) : " ", fillColor: bgColor, style: "tableBody" },
                { text: LeadReport.ClientName, fillColor: bgColor, style: "tableBody" },
                { text: LeadReport.ProjectName, fillColor: bgColor, style: "tableBody" },
                { text: LeadReport.LeadType, fillColor: bgColor, style: "tableBody" },
                { text: `${currency}${USAComma(LeadReport.QuotedValue)}`, fillColor: bgColor, style: "tableBody" },
                { text: LeadReport.Source, fillColor: bgColor, style: "tableBody" },
                { text: LeadReport.Status, fillColor: bgColor, style: "tableBody" },
                { text: LeadReport.AssignedGroup, fillColor: bgColor, style: "tableBody" },
                {
                    text:
                        LeadReport.Status === "Won" || LeadReport.Status === "Lost"
                            ? " "
                            : formatDateByCountry(LeadReport.FollowupDate),
                    fillColor: bgColor,
                    style: "tableBody"
                }
            ];

        });

        const docDefinition = {
            pageSize: "A4",
            pageOrientation: "landscape",

            content: [
                {
                    text: downloadReportTitle,
                    style: "title",
                    margin: [0, 0, 0, 10]
                },
                {
                    table: {
                        headerRows: 1,
                        widths: [30, 60, 70, 70, 50, 65, 50, 60, 60, 70],
                        body: [headerRow, ...bodyRows]
                    },
                    layout: "lightHorizontalLines"
                }
            ],

            styles: {
                title: {
                    fontSize: 10,
                    bold: true
                },
                tableHeader: {
                    bold: true,
                    fontSize: 10
                },
                tableBody: { fontSize: 9 }   // 👈 Add this

            }
        };

        pdfMake.createPdf(docDefinition).download(fileName);
    };

    return { downloadPDF };
};
